
  Vue.component('lr-menu', {
    props: { activeMenu: { type: String, required: true } },
    data() {
      return {
        currentSelected: -1,
        menuItems: [],
        error: false
      }
    },
    template: '#lr-menu',
    computed: {
      countTimesTwo() {
        return this.count * 2
      }
    },
    watch: {
      currentSelected(newValue, oldValue) {
        // console.log(`The value of count is changed from ${oldValue} to ${newValue}.`);
      }
    },
    methods: {
      onClick() {
        this.count += 1
      },
      clickItem(id) {
        if (this.currentSelected && this.currentSelected != -1)
          this.menuItems[this.currentSelected - 1].isActive = false
        this.menuItems[id - 1].isActive = true
        this.currentSelected = id
      }
    },
    mounted() {
      const self = this
      axios
        .get('/api/v1/linkrapidi')
        .then(response => {
          const { data } = response

          self.currentSelected = data.currentSelected
          self.menuItems = data.menuItems

          // ES6 // var found = self.menuItems.find(item => item.menuKeys.indexOf(self.activeMenu) != -1);
          const found = self.menuItems.find(item => item.menuKeys.indexOf(self.activeMenu) != -1)
          if (found) {
            self.currentSelected = found.id
            found.isActive = true
          }
        })
        .catch(error => {
          self.error = true
        })
        .then(() => {
          // always executed
        })
    }
  })
